function PawStraight({ style }) {
  const { fill = '#9191A8', width = 24, height = 24 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M19.875 7.5a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25Zm0 3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25ZM6.75 10.125a2.625 2.625 0 1 0-5.25 0 2.625 2.625 0 0 0 5.25 0ZM4.125 11.25a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm4.5-3a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Zm0-3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm6.75 3.75a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Zm0-3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm2.168 9.456a3.309 3.309 0 0 1-1.582-1.982 4.124 4.124 0 0 0-7.922 0 3.305 3.305 0 0 1-1.57 1.978 3.75 3.75 0 0 0 3.236 6.755 6.009 6.009 0 0 1 4.582 0 3.75 3.75 0 0 0 3.255-6.75v-.001ZM15.75 19.5a2.25 2.25 0 0 1-.886-.18 7.513 7.513 0 0 0-5.737 0 2.25 2.25 0 0 1-1.941-4.057 4.8 4.8 0 0 0 2.293-2.875 2.625 2.625 0 0 1 5.042 0 4.807 4.807 0 0 0 2.3 2.88A2.25 2.25 0 0 1 15.75 19.5Z"
      />
    </svg>
  );
}

export default PawStraight;
